module.exports = __webpack_public_path__ + "img/gradient-creator2_comp.1acb3e00.svg";